import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faAngleLeft, faAngleRight, faMagnifyingGlass, faQuestion } from '@fortawesome/free-solid-svg-icons';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { CryptoService } from 'src/app/services/crypto/crypto.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { KnowledgeBasePageService } from '../knowledge-base/knowledge-base-page-rework/service/knowledge-base-page.service';
import { kbArchiveInterface } from 'src/app/util/interfaces/kbArchive';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-auth-page',
	templateUrl: './auth-page.component.html',
	styleUrls: ['./auth-page.component.scss'],
})
export class AuthPageComponent implements OnInit {
	icons = {
		faQuestion: faQuestion,
		faAngleLeft: faAngleLeft,
		faAngleRight: faAngleRight,
		faMagnifyingGlass: faMagnifyingGlass,
	};

	labels: LabelsInterface = {
		lbl_geral_seja_bem_vindo: 'Welcome',
		lbl_geral_esqueci_senha: '',
		lbl_geral_senha: '',
		lbl_geral_login: '',
		lbl_invalid_login: '',
		lbl_insert_login: '',
		lbl_reset_sent: '',
		lbl_geral_email: '',
		lbl_geral_voltar: '',
		lbl_solicitar_reset: '',
		lbl_qual_sua_duvida: '',
		lbl_nothing_was_found: '',
	};

	customerLogoUrl = 'assets/images/Atos.svg';

	constructor(
		private LabelsService: LabelsService,
		private AuthLoginService: AuthLoginService,
		private CryptoService: CryptoService,
		private KnowledgeBasePageService: KnowledgeBasePageService,
		private Router: Router,
		private ActivatedRoute: ActivatedRoute
	) {}

	isLoadingLabels = true;
	isCheckingRedirect = true;
	isLoadingFaq = false;

	isAlertVisible = false;
	alertMessage = '';

	pageView: 'login' | 'password-reset' | 'faq' = 'login';

	qryString: any = {};

	username = '';
	password = '';
	faqSearch = '';
	faqList: kbArchiveInterface[] = [];

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.searchKb('§allDefault§');

		this.ActivatedRoute.queryParams.subscribe((parameters) => {
			this.qryString = parameters;
			if (parameters && parameters.at) {
				if (!this.AuthLoginService.isLoggedIn()) {
					this.AuthLoginService.checkToken(parameters.at).subscribe(
						() => {
							this.AuthLoginService.setSessionToken(parameters.at);
							if (parameters && parameters.gt) location.href = this.CryptoService.decryptB64(parameters.gt);
							else location.reload();
						},
						() => {
							this.isCheckingRedirect = false;
						}
					);
				}
			} else {
				this.AuthLoginService.checkSAMLLogin(location.hostname).subscribe(
					(redirect) => {
						if (redirect[0].redirect == '') {
							this.isCheckingRedirect = false;
						} else {
							location.href = redirect[0].redirect;
						}
					},
					() => {
						this.isCheckingRedirect = false;
					}
				);
			}
		});
	}

	login(): void {
		this.isAlertVisible = false;
		if (this.username && this.password) {
			this.alertMessage = '';
			this.AuthLoginService.generateSessionToken(this.username, this.password).subscribe(
				(AuthTokenJson: any) => {
					this.AuthLoginService.setSessionToken(AuthTokenJson.authToken);

					if (this.qryString && this.qryString.gt) location.href = this.CryptoService.decryptB64(this.qryString.gt);
					else location.reload();
				},
				(Error: any) => {
					if (Error.status == 401) {
						this.isAlertVisible = true;
						this.alertMessage = this.labels.lbl_invalid_login;
					}
				}
			);
		} else {
			this.isAlertVisible = true;
			this.alertMessage = this.labels.lbl_insert_login;
		}
	}

	requestResetPassword() {
		if (this.isValidEmail()) {
			const pwResetToken = this.CryptoService.encryptAES(this.username);
			localStorage.setItem('pwResetToken', pwResetToken);
			const cryptoB64 = this.CryptoService.encryptB64(pwResetToken);
			this.isAlertVisible = false;
			const currentUrl = new URL(window.location.href).origin;
			this.AuthLoginService.sendMail(this.username, cryptoB64, currentUrl).subscribe();
			this.alertMessage = this.labels.lbl_reset_sent;
			this.isAlertVisible = true;
		}
	}

	verifyInput(event: KeyboardEvent) {
		if (event.key == 'Enter') this.login();
	}

	isValidEmail() {
		if (
			!this.username ||
			this.username.trim() === '' ||
			!/^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|.(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z\-]+\.)+[A-Za-z]{2,}))$/.test(
				this.username.toLowerCase()
			)
		) {
			this.alertMessage = '_Não é um e-mail válido';
			this.isAlertVisible = true;
			return false;
		} else {
			return true;
		}
	}

	searchKb(searchText: string): void {
		if (searchText.trim() == '') {
			this.searchKb('§allDefault§');
			this.faqSearch = '';
		}
		if (this.isLoadingFaq || searchText.trim() == '') return;
		this.isLoadingFaq = true;
		this.KnowledgeBasePageService.bearerlessSearchKb(searchText + '?filter=kb').subscribe(
			(kbRes) => {
				this.faqList = kbRes;
				this.isLoadingFaq = false;
			},
			() => {
				this.faqList = [];
				this.isLoadingFaq = false;
			}
		);
	}

	openKb(idKb: string): void {
		this.Router.navigateByUrl(`/knowledgebase/open/${idKb}`);
	}
}
